import React from 'react'

import { Link } from 'react-router-dom';

import { Section, ActivityFeed, Text, Version } from 'components';
import { Dropdown, Container, Icon } from 'semantic-ui-react';

import { Constants } from 'utils';

//--Constants
const MAX_ACTIVITY = 5;

class PaneActivity extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      activityFilter: ActivityFeed.FILTER_NONE,
      activityMapping: this.getActivityMapping()
    };

    this.handleFilter = this.handleFilter.bind(this);
  }

  handleFilter(event, { value }) {

    this.setState({
      activityFilter: value
    });
  }

  getActivityMapping() {

    return ActivityFeed.Mapping([

      // Synchronization
      {
        type: 'SYNC',
        name: 'Synchronisation',
        content: (payload) => {

          let version = <Version version={payload.version} />

          switch (payload.status) {

            case Constants.STATUS_SYNCHRONIZATION_SUCCESS:
              return {
                icon: (
                  <Icon.Group>
                    <Icon name='sync' />
                    <Icon corner name='checkmark' color="green" />
                  </Icon.Group>
                ),
                content: (
                  <React.Fragment>
                    La valise vient de se synchroniser avec succès en version {version}
                  </React.Fragment>
                )
              }

            case Constants.STATUS_SYNCHRONIZATION_FAILED:

              return {
                icon: (
                  <Icon.Group>
                    <Icon name='sync' />
                    <Icon corner name='dont' color="red" />
                  </Icon.Group>
                ),
                content: (
                  <React.Fragment>
                    La valise vient d'essayer de se synchroniser en version {version}
                  </React.Fragment>
                ),
                extra: `(${Constants.getErrorMessage(payload.error)})`
              };

            default:
              console.error("Reached default case")
              break;

          }
        }
      },

      // Update
      {
        type: 'UPDATE',
        name: 'Mise à jour',
        content: (payload) => {

          let version = <Version version={payload.version} />

          return {
            icon: <Icon name="check circle" color="green" />,
            content: (
              <React.Fragment>
                La version {version} vient d'être installée
              </React.Fragment>
            )
          }
        }
      },

      // Activation
      {
        type: 'ACTIVATE',
        name: 'Activation',
        content: (payload) => {

          return {
            icon: 'flag checkered',
            content: (
              <React.Fragment>
                La valise vient d'être activée avec le code <Text style="mono">{Constants.getActivationCode(payload.code)}</Text>
              </React.Fragment>
            )
          };
        }
      },

      // Desactivation
      {
        type: 'REVOCATE',
        name: 'Désactivation',
        content: (payload) => {

          return {
            icon: (
              <Icon.Group>
                <Icon name='flag checkered' />
                <Icon corner name='times' color="red" />
              </Icon.Group>
            ),
            content: "La valise vient d'être désactivée"
          };
        }
      },

      // Association
      {
        type: 'ASSOCIATE',
        name: 'Association',
        content: (payload) => {

          return {
            icon: 'linkify',
            content: (
              <React.Fragment>
                La valise vient d'être associé à la clinique <Link to={`/clinics/${payload.clinic}`}>#{payload.clinic}</Link>
              </React.Fragment>
            )
          };
        }
      },

      // Dissociation
      {
        type: 'DISSOCIATE',
        name: 'Dissociation',
        content: (payload) => {

          return {
            icon: 'unlink',
            content: (
              <React.Fragment>
                La valise vient d'être dissocié de la clinique <Link to={`/clinics/${payload.clinic}`}>#{payload.clinic}</Link>
              </React.Fragment>
            )
          };
        }
      },

      // Configuration
      {
        type: 'CONFIGURATE',
        name: 'Configuration',
        content: (payload) => {

          return {
            icon: (
              <Icon.Group>
                <Icon name='setting' />
                <Icon corner name='sync' color="green" />
              </Icon.Group>
            ),
            content: (
              <React.Fragment>
                La configuration des capteurs vient d'être mise à jour
              </React.Fragment>
            )
          }
        }
      },

    ]);
  }

  render() {

    const { device } = this.props;
    const { activityMapping } = this.state;

    return (
      <Container>

        <Section title="Activité récente" collapsible actions={[
          <Dropdown icon="filter" value={this.state.activityFilter} options={activityMapping.getFilters()} onChange={this.handleFilter} direction='left' key={0} />,
        ]}>

          {/* Feed */}
          <ActivityFeed filter={this.state.activityFilter} mapping={activityMapping} route={`/devices/${device.id}/activities`} max={MAX_ACTIVITY} />

        </Section>

      </Container>
    )
  }
}

export default PaneActivity;
